import { render, staticRenderFns } from "./studentsBySchool.vue?vue&type=template&id=67c36856&scoped=true&"
import script from "./studentsBySchool.js?vue&type=script&lang=js&"
export * from "./studentsBySchool.js?vue&type=script&lang=js&"
import style0 from "./studentsBySchool.scss?vue&type=style&index=0&id=67c36856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c36856",
  null
  
)

export default component.exports